import { useEffect } from "react";
import { useDebouncedState } from "./useDebouncedState.js";
function useDebouncedValue(value, options) {
  const [debouncedValue, setDebouncedValue, debouncer] = useDebouncedState(
    value,
    options
  );
  useEffect(() => {
    setDebouncedValue(value);
  }, [value, setDebouncedValue]);
  return [debouncedValue, debouncer];
}
export {
  useDebouncedValue
};
//# sourceMappingURL=useDebouncedValue.js.map
